const element = {
    "white": '#ffffff',
    "black": '#525252',
    "primary": '#3C9CFF',
    "success": 'rgb(103, 194, 58)',
    "warning": '#e6a23c',
    "danger": 'rgb(245, 108, 108)',
    "error": '#cf6070',
    "info": '#9c9c9c',
}

const fontSize = {
    xs: '0.10rem',
    sm: '0.12rem',
    base: '0.14rem',
    lg: '0.16rem',
    xl: '0.18rem',
    '2xl': '0.20rem',
    '3xl': '0.22rem',
    '4xl': '0.24rem',
}

export default () => {
    const style = window.getComputedStyle(document.documentElement)
    return JSON.parse(JSON.stringify({
        element,
        text: fontSize,
        header: {
            'bg': '#ffffff',
            'text': '#666666',
        },
        'el-table': {
            'border-color': style.getPropertyValue('--el-border-color-lighter'),
            'row-hover-bg-color': style.getPropertyValue('--el-fill-color-light'),
            'tr-bg-color': style.getPropertyValue('--el-fill-color-blank'),
            'header-bg-color': style.getPropertyValue('--el-fill-color-light'),
        },
        'el-menu': {
            'text-color': style.getPropertyValue('--el-color-black'),
            'hover-text-color': style.getPropertyValue('--el-color-primary'),
            'active-color': style.getPropertyValue('--el-color-primary'),
            'bg-color': '#ffffff',
            'hover-bg-color': style.getPropertyValue('--el-color-primary-light-9'),
            'active-bg-color': style.getPropertyValue('--el-color-primary-light-9'),
        },
        'border-color': '#ebeef5',
        'fill-color': '#f8f8f8',
        'logo-text': '#000000',
    }))
}
